import { useEffect, useState } from "react";
import axios from 'axios';
import Main from '../../../component/Main';

import '../../../css/data-grid.css';
import Button from 'react-bootstrap/Button';

const FidelityTargetManage = () => {


    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth =  today.getMonth()+1;
    if(currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    }


    const [searchParams, setSearchParams] = useState({
        searchYear: currentYear,
        searchMonth: currentMonth,
        searchEmog: '',
        searchLoca: '',
        searchGrdc: '',
        searchType: '01',
        fromindt: currentYear + currentMonth + '01',
        toindt: currentYear + currentMonth + '31',
    });
    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchedTime, setSearchedTime] = useState();

    const rowClass = `${isSearched ? 'grid-animation' : ''} scroll middle`;

    const search = () => {
        if(searchParams.searchEmog === '') {
            alert("먼저 해당 응급의료기관을 선택하십시오.");
        } else {
            setIsLoading(true);
            getfidelityData();
        }
    };

    const controlData = () => {

    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        if(name === 'searchType') {
            setIsSearched(false);
        } 
        if (name === 'searchYear' || name === 'searchMonth') {
            const year = name === 'searchYear' ? value : searchParams.searchYear;
            const month = name === 'searchMonth' ? value : searchParams.searchMonth;
            newParams.fromindt = `${year}${month}01`;
            newParams.toindt = `${year}${month}31`;
        }
        setSearchParams(newParams);
    };

    const [bodylist,setBodyList] = useState([]);
    const head = ['항목', '정상저장률(전국)(%)', '정상저장률(%)', '미상저장률(%)', '미입력률(%)', '재검토율(%)', '오류율(%)'];
    const dataCode = ['FIDELITY_NAME','NATIONAL_NORMAL','ORG_NORMAL','ORG_UNKNOWN','ORG_BLANK','ORG_REVIEW','ORG_ERROR'];
    const except_body = ['PTMIHIBP','PTMILOBP','PTMIPULS','PTMIBRTH','PTMIBDHT','PTMIVOXS'];

    const bodyData = async () => {
        try {
            const response = await axios.get('/ptmiapi/fidelity_list.do',
                { params : {listType : 'ALL'}}
            );

            setBodyList(response.data.fidelitylist);

            
        } catch(e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    const getfidelityData = async () => {
        try {
            const response = await axios.get('/ptmiapi/fidelity_data.do',
                { params: searchParams }
            );

            setIsSearched(true); 
            setIsLoading(false);
                const now = new Date();

                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');  // 0-based
                const date = String(now.getDate()).padStart(2, '0');
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');
                const seconds = String(now.getSeconds()).padStart(2, '0');

                const formatted = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;

            setSearchedTime(formatted);

            
        } catch(e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        bodyData();
    }, []);

    const onClickPopup = (e) => {
        const cls = e.currentTarget.dataset.cls;
        const clsdesc = e.target.dataset.clsdesc;
        const type = e.target.dataset.type;
        const deno = e.target.dataset.deno;
        const sendData = {
            cls : cls,
            clsdesc : clsdesc,
            type : type,
            deno : deno
        }

        let popup = null;

        const totalObj = Object.assign({}, searchParams, sendData)

        if(isSearched && type && deno) {
            localStorage.setItem('sendData',JSON.stringify(totalObj));
            popup = window.open("/nedis/fidelity_2016/send_stat_monthly_popup.do","팝업", "scrollbars=1, resizable=0, width=950, height=500, top=30, left=30");
        }
    }

    
    return (
        <Main>
            <h5 className="sub_title">NEDIS 월별 전송내역 검색</h5>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>영역</th>
                            <td>
                                <select id="searchType" name="searchType" value={searchParams.searchType} onChange={handleInputChange}>
                                    <option value="">전체</option>
                                </select>
                            </td>
                            <th>기관구분</th>
                            <td colSpan="3">
                                <select id="searchType"
                                        name="searchType"
                                        value={searchParams.searchType}
                                        onChange={handleInputChange}
                                >
                                    <option value="01">센터형</option>
                                    <option value="02">기관형</option>
                                </select>
                                <span className="d_orange">* 표출되는 항목에 영향을 줍니다.</span>
                            </td>
                        </tr>
                        <tr></tr>
                    </tbody>
                </table>
            </div>
                <div className='searchBtn'>
                    <div className='flex items-center'><span>{isSearched? searchedTime + " 기준으로 조회 된 데이터 입니다.": ''}</span> </div>
                    <Button size="sm" variant="dark" onClick={search} disabled={isLoading ? 'disabled' : ''}>검색</Button>
                    <Button size="sm" variant="dark"  onClick={controlData} disabled={isLoading ? 'disabled' : ''}>추가</Button>
                </div>
        </Main>
    )
}

export default FidelityTargetManage;